import React from 'react';
import { Fuel, Building2, Ship, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { metiersData, visionData } from '../data/mock';

const iconMap = {
  Fuel: Fuel,
  Building2: Building2,
  Ship: Ship,
};

// Wayne images for each service
const serviceImages = {
  1: "https://customer-assets.emergentagent.com/job_5cce6493-f0af-4302-8a9d-51bbe4853e8f/artifacts/rxparwd0_PHOTO-2025-10-10-21-03-55%209.jpg",
  2: "https://customer-assets.emergentagent.com/job_5cce6493-f0af-4302-8a9d-51bbe4853e8f/artifacts/i4t523ir_Infrastructures%20petrolieres.jpeg",
  3: "https://customer-assets.emergentagent.com/job_5cce6493-f0af-4302-8a9d-51bbe4853e8f/artifacts/vqqvj8q1_Trading%20petrole.jpg",
};

const ServicesSection = () => {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Vision Section */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-orange-100 rounded-full mb-6">
            <span className="text-sm font-medium text-orange-700">Notre Vision</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-6">
            {visionData.title}
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto leading-relaxed">
            {visionData.description}
          </p>
        </div>

        {/* Services Grid */}
        <div className="mb-12">
          <h3 className="text-2xl font-bold text-slate-900 text-center mb-12">
            Nos 3 Métiers
          </h3>
          
          <div className="grid md:grid-cols-3 gap-8">
            {metiersData.map((metier) => {
              const IconComponent = iconMap[metier.icon];
              return (
                <div
                  key={metier.id}
                  className="group relative bg-slate-50 rounded-3xl overflow-hidden hover:shadow-2xl hover:shadow-slate-200/50 transition-all duration-500 border border-transparent hover:border-orange-100"
                >
                  {/* Image */}
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={serviceImages[metier.id]}
                      alt={metier.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent" />
                    
                    {/* Icon overlay */}
                    <div className="absolute bottom-4 left-4 w-12 h-12 bg-white/90 backdrop-blur-sm rounded-xl flex items-center justify-center shadow-lg">
                      <IconComponent className="w-6 h-6 text-orange-500" />
                    </div>
                    
                    {/* Number */}
                    <div className="absolute top-4 right-4 text-5xl font-bold text-white/30">
                      {String(metier.id).padStart(2, '0')}
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    <h4 className="text-xl font-bold text-slate-900 mb-2">
                      {metier.title}
                    </h4>
                    <p className="text-sm font-medium text-orange-500 mb-4">
                      {metier.subtitle}
                    </p>
                    <p className="text-slate-600 leading-relaxed mb-6">
                      {metier.description}
                    </p>

                    {/* CTA */}
                    <a
                      href="#"
                      className="inline-flex items-center text-sm font-medium text-slate-700 group-hover:text-orange-500 transition-colors"
                    >
                      {metier.cta}
                      <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
